export const REQUEST_UNSTARTED = 'REQUEST_UNSTARTED'
export const REQUEST_FETCHING = 'REQUEST_FETCHING';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
